<template>
    <y-panel
        :title="element.title"
        :color="element.color"
        :icon="element.icon"
        class="widget-user-finder"
    >
        <y-loading
            :active="isLoading"
            height="100px"
        >
            <div class="container">
                <!-- Form -->
                <form
                    id="org-finder-form"
                    class="finder-form"
                    @submit.prevent="searchOrg"
                >
                    <y-form-field
                        v-model="query"
                        type="text"
                        :placeholder="$t('dashboard.widgets.org_finder.form.placeholder')"
                        no-label
                        name="search"
                        class="mb0"
                    />
                    <y-button
                        color="blue"
                        loading-on="loading-result-org"
                        form="org-finder-form"
                    >
                        {{ $t('dashboard.widgets.org_finder.form.button') }}
                    </y-button>
                </form>
                <!-- Results - Has Results -->
                <y-loading
                    v-if="results"
                    :active="$wait.is('loading-result-org')"
                    height="100px"
                >
                    <div
                        v-if="results && results.length > 0"
                        class="finder-result"
                    >
                        <!-- Results - Items -->
                        <div
                            v-for="(item, index) in results.slice(0, 5)"
                            :key="index"
                            class="finder-result-item"
                            :class="{'last': index == 4 || index == results.length - 1}"
                        >
                            <div class="finder-result-item-text">
                                <span class="avatar">
                                    <i class="icon md-office-building" />
                                </span>
                                <div>
                                    <span class="finder-result-item-title">{{ item.name_first }}</span>
                                    <span
                                        v-if="item.national_id"
                                        class="finder-result-item-subtitle"
                                    >{{ item.national_id }}</span>
                                </div>
                            </div>
                            <y-button
                                tag="router-link"
                                :to="{ name: 'icib-organizations-list', query: { id: item.id } }"
                                size="xs"
                            >
                                {{ $t('dashboard.widgets.org_finder.result.view_profile') }}
                            </y-button>
                        </div>

                        <!-- Results - Footer -->
                        <div
                            v-if="results && results.length > 5"
                            class="finder-result-footer"
                        >
                            <y-button
                                size="xs"
                                @click="moreResultLink"
                            >
                                {{ $t('dashboard.widgets.org_finder.result.more_result') }}
                            </y-button>
                        </div>
                    </div>

                    <!-- Results - No Result -->
                    <y-empty-state
                        v-else
                        height="250"
                        class="mb0"
                        :title="$t('dashboard.widgets.org_finder.result.no_result')"
                    />
                </y-loading>
            </div>
        </y-loading>
    </y-panel>
</template>

<script>
    import YFormField from '@deps/form/FormField';
    import WidgetMixin from '@/mixins/Widget';

    export default {

        name: 'OrganizationFinderWidget',

        components: {
            YFormField,
        },

        mixins: [WidgetMixin],

        props: {

            /**
             * Widget element
             */
            element: Object,

        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                query  : '',
                results: null,
                loading: false,
            };
        },

        /**
         * @inheritDoc
         */
        created() {
            this.stopLoading();
        },

        methods: {

            /**
             * Search
             */
            searchOrg() { // eslint-disable-line
                if (!this.query) {
                    return false;
                }
                this.$wait.start('loading-result-org');
                this.updated();
                this.results = null;
                const params = {
                    id    : this.element.id,
                    search: this.query,
                };
                this.$services.Panel.widgetContent(params).then((response) => {
                    this.results = response.data.results;
                }).catch((errorResponse) => {
                    this.handleError(errorResponse);
                }).finally(() => {
                    this.$wait.end('loading-result-org');
                    this.updated();
                });
            },

            /**
             * More Result Link
             */
            moreResultLink() {
                this.$router.push({
                    name : 'icib-organizations-list',
                    query: {
                        search: this.query,
                    },
                });
            },

        },

    };
</script>
